import React, { Component } from "react";
import "./index.scss";
import { GenerateAtribute } from "../../@utils/generate-atribute";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { OwnIcon } from "../../@component/icons/module-icons";

export class GaleryHero extends Component {
  static defaultProps = {
    dismiss: null,
    show: null,
    galery: [],
    activeImage: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      thumbsSwiper: null,
    };
  }

  getElementConfig = (props) => {
    return GenerateAtribute(props);
  };

  setThumbsSwiper = (swiper) => {
    this.setState({ thumbsSwiper: swiper });
  };

  onOpen = (img) => () => {
    this.setState({ activeImage: img });
  };

  render() {
    const { props, state } = this;
    const photos = props.galery || [];

    return (
      <section style={{ width: "100%", display: "flex", flexDirection: "column" }} {...this.getElementConfig(props)} className={`fox_backgroud_slider_side ${props.className}`}>
        {/* Main slider */}
        <div className="slider_galery_box">
          <Swiper
            modules={[Navigation, Thumbs]}
            navigation
            thumbs={{
              swiper: state.thumbsSwiper && !state.thumbsSwiper.destroyed ? state.thumbsSwiper : null,
            }}
            className="rounded-xl shadow-lg"
          >
            {photos.map((img, idx) => (
              <SwiperSlide key={idx} onClick={this.onOpen(img.src)}>
                <img src={img.src} alt={`Slide ${idx}`} className="w-full h-full object-cover rounded-xl" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Thumbnails */}
        <Swiper onSwiper={this.setThumbsSwiper} spaceBetween={10} slidesPerView={5} watchSlidesProgress modules={[Thumbs]} className="mt-4">
          {photos.map((img, idx) => (
            <SwiperSlide key={idx} className="cursor-pointer">
              <img src={img.src} alt={`Thumb ${idx}`} className="w-full h-full object-cover rounded-lg border" />
            </SwiperSlide>
          ))}
        </Swiper>
        {state.activeImage && (
          <div className="zoom_posizion">
            <div className="zoom_box">
              <div className="button_close" onClick={this.onOpen(null)}>
                <OwnIcon type="close" />
              </div>
              <div className="zoom_container">
                <img src={state.activeImage} alt={"ulamulem.com"} />
              </div>
            </div>
          </div>
        )}
      </section>
    );
  }
}
